import { createReducer, on } from '@ngrx/store';

import { UserDetailResponseBody } from '#types/admin';

import * as AdminActions from './admin.actions';

export interface AdminState {
  detail: {
    data: UserDetailResponseBody;
  };
}

export const initialState: AdminState = {
  detail: {
    data: null,
  },
};

export const reducer = createReducer<AdminState>(
  initialState,

  // admin/user-detail

  on(
    AdminActions.DetailInitialize,
    (state): AdminState => ({
      ...state,
      detail: {
        ...state.detail,
      },
    })
  ),

  on(
    AdminActions.DetailRequestData,
    (state): AdminState => ({
      ...state,
      detail: {
        ...state.detail,
        data: null,
      },
    })
  ),

  on(
    AdminActions.DetailRequestDataSuccess,
    (state, action): AdminState => ({
      ...state,
      detail: {
        ...state.detail,
        data: {
          ...action.data,
        },
      },
    })
  ),

  on(
    AdminActions.DetailRequestDataFailure,
    (state, _action): AdminState => ({
      ...state,
      detail: {
        ...state.detail,
      },
    })
  ),

  on(
    AdminActions.DetailClearData,
    (state): AdminState => ({
      ...state,
      detail: {
        ...state.detail,
        data: null,
      },
    })
  )
);
